import { render, staticRenderFns } from "./RobberyMethodQuestion.vue?vue&type=template&id=bbe0b9f4&scoped=true"
import script from "./RobberyMethodQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyMethodQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyMethodQuestion.vue?vue&type=style&index=0&id=bbe0b9f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe0b9f4",
  null
  
)

export default component.exports